import { NotificationsNone } from '@mui/icons-material';
import { Badge, IconButton, Toolbar, typographyClasses } from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import { ReactNode, useState } from 'react';
import { MenuBars } from '../icons';
import { useIsMobile } from '../models/Hooks';
import { NavIconButton } from '../components/NavLink';
import { getUser } from '../models/Identity';
import { isMobile } from '../utils';

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}  

const StyledAppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    /**
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
    /**/
}));

export default StyledAppBar;

export function TopAppBar({ left, right }: { left: ReactNode, right?: ReactNode }) {
    const ism = useIsMobile();
    const [open, setOpened] = useState(!ism);

    return <>
        <StyledAppBar position="relative" open={open} elevation={0}>
            <Toolbar sx={{
                px: isMobile() ? 1 : undefined,
                gap: 1,
                [`& > .${typographyClasses.root}`]: {
                    display: 'flex',

                }
            }}>
                {left}
                <div style={{ flex: 1 }} />
                {right || <NavIconButton route={[['page', 'notifications']]}>
                    {getUser().HasNotifications ? <Badge color="error" variant="dot" overlap="circular">
                        <NotificationsNone color="primary" />
                    </Badge> : <NotificationsNone color="primary" />}
                </NavIconButton>}
                {ism ? null : <IconButton onClick={() => setOpened(!open)}>{MenuBars}</IconButton>}
            </Toolbar>
        </StyledAppBar>

        {/**<AppDrawer key={'drawer' + open} open={open} />/**/}
    </>;
}